import "./coomingSoon.css";

export default function ComingSoon() {
    return (
      <div className="comingSoonContainer">
        <h2>Coming Soon</h2>
        <p>We’re working hard to bring you this feature.</p>
      </div>
    );
  }